import React, { useState, useEffect } from "react";
import bayrakGif from "../img/bayrak.gif";
import kudiImage from "../img/log10.png";
import "../styles/Header.css";

const Header = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleBayrakClick = () => {
    window.location.href = "/admin"; // Bayrak tıklandığında /admin sayfasına yönlendirir
  };

  const toggleFullScreen = () => {
    // Eğer tam ekran modunda değilse
    if (!document.fullscreenElement) {
      // Tam ekran moduna geç
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) { // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari ve Opera
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) { // Internet Explorer/Edge
        document.documentElement.msRequestFullscreen();
      }
      
      // Global tam ekran sınıflarını ekle
      document.body.classList.add('fullscreen');
      document.getElementById('root').classList.add('fullscreen');
      
      // Scrollu kesinlikle engelle
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      setIsFullScreen(true);
    } else {
      // Tam ekran modundan çık
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // Chrome, Safari ve Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // Internet Explorer/Edge
        document.msExitFullscreen();
      }
      
      // Global tam ekran sınıflarını kaldır
      document.body.classList.remove('fullscreen');
      document.getElementById('root').classList.remove('fullscreen');
      
      // Scrollu geri aç
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
      
      setIsFullScreen(false);
    }
  };

  // Tam ekran değişimlerini izle
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!document.fullscreenElement;
      setIsFullScreen(isFullscreen);
      
      // Tam ekran sınıflarını ekle veya kaldır
      if (isFullscreen) {
        document.body.classList.add('fullscreen');
        document.getElementById('root').classList.add('fullscreen');
        
        // Scrollu kesinlikle engelle
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.classList.remove('fullscreen');
        document.getElementById('root').classList.remove('fullscreen');
        
        // Scrollu geri aç
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
      
      // Temizlik için scrollu geri aç
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className={`header-container ${isFullScreen ? 'fullscreen' : ''}`}>
      <img
        src={bayrakGif}
        alt="Bayrak"
        className="header-logo float-effect"
        onClick={handleBayrakClick}
      />
      <div className="header-content">
        <h1 className="header-title">
        CANLI ALTIN BORSASI
          <span className="underline active"></span>{" "}
          {/* Altındaki çizgiyi sürekli aktif hale getirir */}
        </h1>
      </div>
      <img
        src={kudiImage}
        alt="İKUD"
        className="header-logo kudi-logo float-effect"
        onClick={toggleFullScreen}
        title={isFullScreen ? "Tam Ekrandan Çık" : "Tam Ekrana Geç"}
      />
    </div>
  );
};

export default Header;
